import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { propMatch } from '@/helpers/custom-prop-types';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { showAlert } from '../../../actions/NotificationActions';
import { API_GET_ONE_SOLUTION, apiGetOneSolution, } from '../../../actions/OneSolutionActions';
import { ORDER_ERROR_MESSAGES } from '../../../define/consts/solution_order';
import { isLoadingApis } from '../../../helpers/fetch';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import OrderContent from './OrderContent';
const Order = (props) => {
    const { match } = props;
    const { params: { id }, url, } = match || {};
    const history = useNavigate();
    const { isForbidden, isLoading, item } = useSelector(({ fetch, oneSolution }) => {
        const one = oneSolution[id] || {};
        return {
            isForbidden: !!one.forbidden,
            isLoading: isLoadingApis(fetch, API_GET_ONE_SOLUTION),
            item: one.one || null,
        };
    });
    const dispatch = useDispatch();
    const isProffit = useMemo(() => url.indexOf('proffit_order') > 0, [url]);
    useEffect(() => {
        if (!item) {
            dispatch(apiGetOneSolution(id, {
                resolve: ({ payload }) => {
                    const messages = ORDER_ERROR_MESSAGES[payload.inquiryStatus] || '';
                    if (!isProffit && messages) {
                        dispatch(showAlert(messages));
                        history.push(`/solutions/${id}`);
                    }
                },
            }));
        }
    }, [history, dispatch, id, item, isProffit]);
    const submitOrder = useCallback(() => {
        history.push(`/solutions/${id}/order/confirm`);
    }, [history, id]);
    if (isForbidden) {
        return _jsx(CustomRedirect, { to: `/solutions/${id}/` });
    }
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main archives' }, { children: _jsx(OrderContent, { isLoading: !item || isLoading, isProffit: isProffit, item: item, submitOrder: submitOrder }) })));
};
Order.propTypes = {
    match: propMatch(),
};
export default AuthenticationHoc({
    isCanUseProffitMart: true,
    isClient: true,
})(Order);
